import { createTestId } from 'utils';
import React, { useLayoutEffect } from 'react'
import classnames from "classnames"
import { motion, AnimatePresence } from "framer-motion"
import * as Icon from "react-feather"
import PerfectScrollbar from 'react-perfect-scrollbar'

const AsidePanel = (props) => {
    const { showAside, title, isBackdrop = true } = props

    useLayoutEffect (() => {
        if(showAside){
            document.body.classList.add("overflow-hidden")
        }
        return () => document.body.classList.remove("overflow-hidden")
    },[showAside])

    return (
        <AnimatePresence>
            {
                showAside && (
                    <motion.div className="aside-overlay" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>

                        <div data-testid={createTestId('div', 'AsidePanel', 1)} onClick={() => { isBackdrop && props.close() }} className="aside-close"></div>

                        <motion.div className={classnames('aside-panel', props.className)} initial={{ right: -window.innerWidth * 0.2 }} animate={{ right: 0 }} exit={{ right: -window.innerWidth * 0.2 }}>
                            <div className="panel-header">
                                <h5 className="text-xl font-medium mb-4">{title}</h5>
                                <button className="btn-close" data-testid={createTestId('button', 'AsidePanel', 2)} onClick={() => { props.close() }}>
                                    <Icon.X />
                                </button>
                                <hr className="divider" />
                            </div>
                            <PerfectScrollbar className="panel-body">
                                <div className="relative flex flex-col h-auto lg:min-h-full">
                                    {
                                        props.children
                                    }
                                </div>
                            </PerfectScrollbar>
                        </motion.div>
                    </motion.div>
                )
            }
        </AnimatePresence>
    )
}

export default AsidePanel